import React from "react";

import "./index.scss";

interface LabelProps {
  title: string;
  className?: string;
}

const Label = (props: LabelProps) => {
  const { title, className } = props;

  return <label className={className}>{title}</label>;
};

export default Label;
